import "./App.scss";
import MajorRoutes from "./MajorRoutes";

/**
 * The application root.
 *
 * It renders the router and nothing else. The previous version mounted a
 * hidden Chat component here to keep an Azure Communication Services client
 * alive for the whole session; chat is now a stream owned by the conversation
 * query and opened only while a conversation is on screen, so there is nothing
 * left to keep warm.
 */
const App = () => <MajorRoutes />;

export default App;
